if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();

        this.navButtons = Array.from(this.querySelectorAll('[data-modal-nav]'));
        this.navButtons.forEach((button) => {
          // The media-modal-wide pointerup listener a few lines up (inherited
          // from ModalDialog) treats any click outside deferred-media/
          // product-model as "click outside the photo, close the modal" -
          // without stopping it here, clicking these nav buttons would close
          // the modal instead of stepping to the next/previous item.
          button.addEventListener('pointerup', (event) => event.stopPropagation());
          button.addEventListener('click', () => this.showMediaByOffset(parseInt(button.dataset.modalNav, 10)));
        });

        this.addEventListener('keyup', (event) => {
          if (event.code === 'ArrowRight') this.showMediaByOffset(1);
          if (event.code === 'ArrowLeft') this.showMediaByOffset(-1);
        });
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();

        const mediaCount = this.querySelectorAll('[data-media-id]').length;
        this.navButtons.forEach((button) => button.toggleAttribute('hidden', mediaCount < 2));
      }

      showActiveMedia() {
        this.setActiveMediaById(this.openedBy.getAttribute('data-media-id'));
      }

      showMediaByOffset(step) {
        const items = Array.from(this.querySelectorAll('[data-media-id]'));
        if (items.length < 2) return;
        const currentIndex = items.findIndex((item) => item.classList.contains('active'));
        const nextItem = items[(currentIndex + step + items.length) % items.length];
        this.setActiveMediaById(nextItem.dataset.mediaId);
      }

      setActiveMediaById(mediaId) {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${mediaId}"])`).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${mediaId}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
